// Base API URL - adjust this based on your environment
const getApiUrl = () => {
    switch (process.env.REACT_APP_ENV) {
      case 'production':
        return process.env.REACT_APP_API_URL || 'https://your-production-api.com';
      default:
        return process.env.REACT_APP_API_URL || 'http://localhost:8080';
    }
  };
  
  export const API_URL = getApiUrl();
  
  export const endpoints = {
    signin: `${API_URL}/auth/signin`,
    signup: `${API_URL}/auth/signup`,
    // resetpPassword: `${API_URL}/auth/reset-password`,
  
  }; 